import ModifyDateDialog from 'components/Dialogs/ModifyDateDialog';
import Task from 'models/tasks/task';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ITaskModifyCompletionDateProps {
  task: Task;
  isOpen: boolean;
  onClose: () => void;
  onSave: (completionDate: Date) => void;
}

const TaskModifyCompletionDate = (props: ITaskModifyCompletionDateProps) => {
  const { t } = useTranslation(['task', 'translation']);
  const [newCompletionDate, setNewCompletionDate] = useState<Date | undefined>(props.task.completed);

  return (
    <ModifyDateDialog
      title={t('task:Completed.DialogChangeTitle')}
      subTitle={t('task:Completed.DialogChangeSubTitle')}
      isOpen={props.isOpen}
      value={newCompletionDate}
      allowChangeTime={true}
      onSave={() => {
        if (newCompletionDate) props.onSave(newCompletionDate);
      }}
      onUpdate={setNewCompletionDate}
      onClose={() => props.onClose()}
    />
  );
};

export default TaskModifyCompletionDate;
